module.exports = __webpack_public_path__ + "img/earn_youtuber.3bd84e73.svg";